// Calculator-specific properties for each province (EHT, holidays, etc.)
export const PROVINCE_CALCULATOR_DATA: Record<string, {
  hasEHT: boolean;
  ehtThreshold: number;
  ehtRate: number;
  defaultPublicHolidays: number;
}> = {
  "ON": { hasEHT: true, ehtThreshold: 1000000, ehtRate: 1.95, defaultPublicHolidays: 9 },
  "QC": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 8 },
  "AB": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 9 },
  "BC": { hasEHT: true, ehtThreshold: 500000, ehtRate: 1.95, defaultPublicHolidays: 10 },
  "MB": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 8 },
  "NB": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 8 },
  "NL": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 6 },
  "NS": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 6 },
  "PE": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 7 },
  "SK": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 10 },
  "NT": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 10 },
  "NU": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 9 },
  "YT": { hasEHT: false, ehtThreshold: 0, ehtRate: 0, defaultPublicHolidays: 10 },
};

export const CPP_QPP_EI_RATES = {
  CPP: { rate: 5.95, maxContribution: 3867.5, maxEarnings: 68500 },
  QPP: { rate: 6.4, maxContribution: 4275.6, maxEarnings: 68500 },
  EI: { rate: 2.32, maxContribution: 1050.5, maxEarnings: 54200 },
};

// Sample WSIB/WCB codes for reference (currently unused in favor of API data)
export const WSIB_WCB_SAMPLE = [
  { code: "8810", description: "Clerical Office Employees", rate: 0.8, province: "ON" },
  { code: "7219", description: "Machinery Installers", rate: 3.2, province: "AB" },
  { code: "4020", description: "Construction", rate: 4.5, province: "ON" },
  { code: "5140", description: "Retail", rate: 1.2, province: "BC" },
  { code: "9015", description: "Professional Services", rate: 0.6, province: "QC" },
  { code: "7330", description: "Plumbing", rate: 3.8, province: "ON" },
  { code: "8017", description: "Retail Stores", rate: 1.1, province: "AB" },
  { code: "8601", description: "Architects & Engineers", rate: 0.3, province: "BC" },
  { code: "8742", description: "Outside Sales", rate: 0.4, province: "ON" },
  { code: "8820", description: "Legal Services", rate: 0.25, province: "QC" },
]; 